/* OnboardingDialog.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmp0Oa%7Bpadding-block-start%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5Ep0Oa%7Bpadding-inline-start%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPp0Oa%7Bpadding-inline-end%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkop0Oa%7Bpadding-block-end%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3CkH9owZHM%7Bbackground-image%3Alinear-gradient(to%20right%2Cvar(--ds-border-disabled%2C%230515240f)%201px%2Ctransparent%201px)%2Clinear-gradient(to%20bottom%2Cvar(--ds-border-disabled%2C%230515240f)%201px%2Ctransparent%201px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3OqcjTBsdA%7Bbackground-size%3A37.29px%2037.29px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1DJ2rVUH3o%7Bbackground-position%3A17.58px%2021.37px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrud1Zr%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV0268oq%7Bwidth%3A818px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr0F05b%7Balign-self%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmGXk2%7Bpadding-block-start%3Avar(--ds-space-800%2C4pc)%7D");
import React, { useCallback, useState } from 'react';
import Button from '@atlaskit/button/default/button';
import IconButton from '@atlaskit/button/icon/button';
import Heading from '@atlaskit/heading/heading';
import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import CloseIcon from '@atlaskit/icon/core/cross';
import HeartIcon from '@atlaskit/icon/core/heart';
import PersonIcon from '@atlaskit/icon/core/person';
import TeamsIcon from '@atlaskit/icon/core/teams';
import Image from '@atlaskit/image/image';
import { TeamsLogo } from '@atlaskit/logo';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { useIntl, FormattedMessage } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { useCreateTeamModal } from '@townsquare/create-team-modal';
import { TeamsScreenSpaceFlagsChangeBoarding } from '@townsquare/post-office/placements';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { teamProfileRoute } from '@townsquare/routes/team-profile';
import OnboardingImage from '../../assets/OnboardingImage.svg';
const styles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn",
  leftSide: "_46hvQmp0Oa _0LQT5Ep0Oa _03SyCPp0Oa _0xmtkop0Oa",
  rightSide: "_3CkH9owZHM _3OqcjTBsdA _1DJ2rVUH3o _0KLXrud1Zr _39xV0268oq _0jFU0VN91d",
  closeButton: "_4xdlr0F05b _1mT5xdWVPG _46hvQm5zaO _03SyCP5zaO",
  actionButtons: "_46hvQmGXk2"
};
type OnboardingModalProps = {
  isOpen: boolean;
  focusRef: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  onCreateTeam: () => void;
};

// The design requires the close button to be positioned differently so not showing the default close button
/* eslint-disable @atlaskit/design-system/use-modal-dialog-close-button */
const OnboardingModal = ({
  isOpen,
  focusRef,
  onClose,
  onCreateTeam
}: OnboardingModalProps) => {
  const intl = useIntl();
  return <ModalTransition>
			{isOpen && <Modal onClose={onClose} width="x-large" autoFocus={focusRef}>
					<Inline grow="fill" xcss={styles.container}>
						<Box xcss={styles.leftSide}>
							<Stack space="space.1000">
								<Stack space="space.500" grow="fill">
									<Inline alignInline="start">
										<TeamsLogo size="small" />
									</Inline>
									<Stack space="space.300">
										<Stack space="space.100">
											<Heading size="medium">
												<FormattedMessage id="townsquare.teams-app.onboarding-dialog.title" description="Title of the onboarding dialog" defaultMessage="Connect the dots with Teams" />
											</Heading>
											<Text>
												<FormattedMessage id="townsquare.teams-app.onboarding-dialog.subtitle" description="Subtitle of the onboarding dialog" defaultMessage="Find anyone in your organization and see who they are working with and what they are working on" />
											</Text>
										</Stack>
										<Stack space="space.200">
											<Inline space="space.100" alignBlock="center">
												<TeamsIcon label="" color={"var(--ds-text-selected, #1868DB)"} />
												<Text>
													<FormattedMessage id="townsquare.teams-app.onboarding-dialog.description-team" description="Description about teams in the onboarding dialog" defaultMessage="Connect your team to the places they collaborate" />
												</Text>
											</Inline>
											<Inline space="space.100" alignBlock="center">
												<PersonIcon label="" color={"var(--ds-text-selected, #1868DB)"} />
												<Text>
													<FormattedMessage id="townsquare.teams-app.onboarding-dialog.description-people" description="Description about people in the onboarding dialog" defaultMessage="Browse a directory of everyone you work with" />
												</Text>
											</Inline>
											<Inline space="space.100" alignBlock="center">
												<AiAgentIcon label="" color={"var(--ds-text-selected, #1868DB)"} />
												<Text>
													<FormattedMessage id="townsquare.teams-app.onboarding-dialog.description-agents" description="Description about agents in the onboarding dialog" defaultMessage="Find helpful agents and add them to your teams" />
												</Text>
											</Inline>
											<Inline space="space.100" alignBlock="center">
												<HeartIcon label="" color={"var(--ds-text-selected, #1868DB)"} />
												<Text>
													<FormattedMessage id="townsquare.teams-app.onboarding-dialog.description-kudos" description="Description about kudos in the onboarding dialog" defaultMessage="Show gratitude to your colleagues with Kudos" />
												</Text>
											</Inline>
										</Stack>
									</Stack>
								</Stack>
								<Inline space="space.075" alignInline="end" xcss={styles.actionButtons}>
									<Button appearance="subtle" onClick={onCreateTeam}>
										<FormattedMessage id="townsquare.teams-app.onboarding-dialog.create-team-button" description="Button text to create a new team in the onboarding dialog" defaultMessage="Create a new team" />
									</Button>
									<Button appearance="primary" onClick={onClose}>
										<FormattedMessage id="townsquare.teams-app.onboarding-dialog.browse-teams-button" description="Button text to browse teams in the onboarding dialog" defaultMessage="Get started" />
									</Button>
								</Inline>
							</Stack>
						</Box>
						<Stack grow="fill" xcss={styles.rightSide} alignBlock="center">
							<Image src={OnboardingImage} alt="" />
						</Stack>
					</Inline>
					<Box xcss={styles.closeButton}>
						<IconButton appearance="subtle" icon={CloseIcon} label={intl.formatMessage({
          id: 'townsquare.teams-app.onboarding-dialog.close-button-label',
          description: 'Accessible label for the close button in the onboarding dialog',
          defaultMessage: 'Close the onboarding dialog'
        })} onClick={onClose} ref={focusRef} />
					</Box>
				</Modal>}
		</ModalTransition>;
};
export const OnboardingDialog = (): React.JSX.Element => {
  const {
    pushTo
  } = useRouterActions();
  const [isOpen, setIsOpen] = useState(true);
  const analytics = useAnalytics();
  const focusRef = React.useRef<HTMLButtonElement>(null);
  const {
    openCreateTeamModal
  } = useCreateTeamModal({
    analyticsCtx: {
      source: 'teamsOnboarding'
    },
    onCreate: team => pushTo(teamProfileRoute, {
      params: {
        id: team.id
      }
    })
  });
  const closeModal = useCallback((onDismiss: () => void) => {
    analytics.ui('teamsOnboardingDialog', 'closed');
    onDismiss();
    setIsOpen(false);
  }, [setIsOpen, analytics]);
  const onCreateTeamClicked = (onDismiss: () => void) => {
    closeModal(onDismiss);
    openCreateTeamModal();
  };
  return <TeamsScreenSpaceFlagsChangeBoarding featureId="teams-app-onboarding-dialog">
			{({
      onDismiss
    }) => <OnboardingModal isOpen={isOpen} focusRef={focusRef} onClose={() => closeModal(onDismiss)} onCreateTeam={() => onCreateTeamClicked(onDismiss)} />}
		</TeamsScreenSpaceFlagsChangeBoarding>;
};